import type StaticMapSize from '@alltrails/types/StaticMapSize';
import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';
import { X_AT_KEY } from './api';

type Args = {
  id: string | number;
  size: PhotoSizeDimensions;
  staticMapScale: number;
  staticMapSize: StaticMapSize;
};

const getTrailProfilePhotoUrl = ({ id, size, staticMapScale, staticMapSize }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('show_static_map', 'true');
  params.set('size', getPhotoSizeServerFromDimensions(size));
  params.set('static_map_scale', String(staticMapScale));
  params.set('static_map_size', staticMapSize);

  return `/api/alltrails/v3/trails/${id}/profile_photo?${params.toString()}`;
};

export default getTrailProfilePhotoUrl;
